export default __webpack_public_path__ + "static/media/air-filter.3daa7548.jpg";